import { createSlice } from '@reduxjs/toolkit';

import {
  DemoVideosInterface,
  DemoVideosReceivedAction,
  FetchDemoVideosAction,
  GetSpecificDemoVideosAction,
  SpecificDemoVideosReceivedAction
} from '../actions/Demovideos';

const initialState: DemoVideosInterface = {
  demoVideos: null,
  isFetchingDemoVideos: false,
  video_link: null,
  isFetchingVideo: false
};

const DemoVideos = createSlice({
  name: 'DemoVideos',
  initialState,
  reducers: {
    getDemoVideos: (state, _action: FetchDemoVideosAction) => {
      state.isFetchingDemoVideos = true;
    },

    demoVideosReceived: (state, action: DemoVideosReceivedAction) => {
      state.isFetchingDemoVideos = false;
      state.demoVideos = action.payload.demoVideos;
    },

    getspecificdemoVideos: (state, _action: GetSpecificDemoVideosAction) => {
      state.isFetchingVideo = true;
    },
    specificdemoVideosReceived: (
      state,
      action: SpecificDemoVideosReceivedAction
    ) => {
      state.isFetchingVideo = false;
      state.video_link = action.payload.video_link;
    }
  }
});

export const {
  getDemoVideos,
  demoVideosReceived,
  getspecificdemoVideos,
  specificdemoVideosReceived
} = DemoVideos.actions;
export default DemoVideos.reducer;
